/**
 * Blog Index — client-side topic filter.
 *
 * Toggles post cards by category slug when a filter chip is clicked. Cards
 * carry a space-separated `data-categories`; chips carry `data-filter`
 * ("all" shows everything). Falls back gracefully when the block is absent.
 */
export function initBlogFilter() {
    document.querySelectorAll('[data-blog-filter]').forEach((bar) => {
        const section = bar.closest('section') || document;
        const grid = section.querySelector('[data-blog-grid]');
        if (!grid) return;

        const cards = Array.from(grid.querySelectorAll('.blog-card'));
        const empty = section.querySelector('[data-blog-empty]');
        const chips = Array.from(bar.querySelectorAll('.blog-chip'));

        const apply = (filter) => {
            let shown = 0;
            cards.forEach((card) => {
                const cats = (card.getAttribute('data-categories') || '').split(/\s+/);
                const match = filter === 'all' || cats.indexOf(filter) !== -1;
                card.classList.toggle('hidden', !match);
                if (match) shown += 1;
            });
            if (empty) empty.classList.toggle('hidden', shown !== 0);
        };

        chips.forEach((chip) => {
            chip.addEventListener('click', () => {
                chips.forEach((c) => {
                    const on = c === chip;
                    c.classList.toggle('is-active', on);
                    c.setAttribute('aria-pressed', on ? 'true' : 'false');
                });
                apply(chip.getAttribute('data-filter') || 'all');
            });
        });
    });
}
